import { BaseTicketController } from '../../../../common/base/ticketController';
import { TicketType } from '../../ticket.constants';

export class SelectController extends BaseTicketController {
  constructor(controllerService, ticketService) {
    'ngInject';
    super({ controllerService, ticketService });
  }

  $onInit() {
    super.$onInit();

    this.pdfUrl = this.ticketService.getSignedWarrantUrl(this.ticket.id);

    this.optInSelection = this.isFeatureActive(
      this.FeatureNames.FF_OLD_BANK_FINANCES_OPT_IN,
    );

    this.ticketService
      .fetchTransactions(TicketType.Transferring, this.ticket.id)
      .then((finances) => {
        this.setFinances(finances);
      });
  }

  setFinances(finances) {
    this.finances = {
      directDebits: this.getDirectDebitsFromFinances(finances),
      receivedPayments: this.getReceivedPaymentsFromFinances(finances),
      standingOrders: this.getStandingOrdersFromFinances(finances),
    };
  }

  selectFinanceItem(item, selected = true) {
    item.selected = selected;
  }

  getDirectDebitsFromFinances(finances) {
    const debits = finances.debits || finances.directDebits;

    if (debits) {
      debits.map((item) => {
        // Get rid off all unique debits (00FF)
        if (item.sequenceType === 'OOFF') {
          this.selectFinanceItem(item, false);
        }

        // Get rid off all debits without creditor ID and/or mref
        if (!item.creditorId || !item.mref) {
          this.selectFinanceItem(item, false);
        }
      });
    }

    return debits;
  }

  getReceivedPaymentsFromFinances(finances) {
    const payments = finances.deposits || finances.receivedPayments;

    if (payments) {
      payments.map((item) => {
        // Get rid off all payments without a name
        if (!item.name) {
          this.selectFinanceItem(item, false);
        }
      });
    }

    return payments;
  }

  getStandingOrdersFromFinances(finances) {
    // Concat standingOrders with scheduledTransactions
    return (finances.transfers || finances.standingOrders || []).concat(
      finances.scheduledTransactions || [],
    );
  }

  submit(finances) {
    this.ticketService.putFinancesOutgoing(this.ticket.id, finances);
  }
}
